// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2p6jX","errorLogs":"EditorFooter_errorLogs__CLqQd"};